// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, Button, Center, Space, Stack, Text, Title } from '@mantine/core';
import { IconCalendarEvent } from '@tabler/icons';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import EmptyListState from '../../Molecules/EmptyListState';
import CreateEventIcon from './CreateEventIcon';
import { ThemeText, ThemeTitle } from '../../Atoms/ThemeText';

const EventsNotFound: FC<{ totalCount: number }> = ({ totalCount }) => (
  <Stack>
    {totalCount === 0 && <AcademySection />}
    <EmptyListState
      icon={<IconCalendarEvent size={30} stroke={1.6} />}
      title={totalCount === 0 ? 'Noch keine Events' : 'Keine Events gefunden'}
      maxWidth={totalCount === 0 ? 640 : undefined}
    >
      {totalCount === 0 ? (
        <Center inline>
          Du hast noch kein Event erstellt. Klicke auf
          <Space w={5} />
          <CreateEventIcon />
          <Space w={2} /> um zu beginnen.
        </Center>
      ) : (
        <>
          Die Kombination der ausgewählten <b>Filter</b> erzielt keine Ergebnisse.
        </>
      )}
    </EmptyListState>
  </Stack>
);

const AcademySection = () => {
  const navigate = useNavigate();

  return (
    <Box p="sm" sx={{ border: '2px solid #E2E2E2', borderRadius: 5 }}>
      <ThemeTitle align="center" order={5} mb="sm">
        Herzlich Willkommen bei bookitup!
      </ThemeTitle>
      <ThemeText align="center" mb="sm">
        Wichtig: Starte am Besten in unserer Akademie. Dort bekommst du eine <b>Schritt für Schritt Anleitung</b>, um
        bookitup einzurichten und damit die Büroarbeit hinter deinem Event-Job deutlich zu reduzieren.
      </ThemeText>
      <Center>
        <Button size="xs" sx={{ width: 200 }} onClick={() => navigate('/academy/welcome')}>
          Jetzt loslegen!
        </Button>
      </Center>
    </Box>
  );
};

export default EventsNotFound;
